import {
  Box,
  Container,
  IconButton,
  Link,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { Squash as Hamburger } from 'hamburger-react'
import { Dispatch, SetStateAction, useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { NavBar, StyledInvestmentAccountButton } from '@features/app-bar'

import { useMobileMenu } from '@entities/app-bar'

import { ReactComponent as FundLogo } from './assets/arbitas-logo-fund.svg'

import { LangMenu } from './components'
import MobileMenu from './mobile-menu'
import {
  StyledAppBar,
  StyledToolbar,
  StyledDrawer,
  StyledLogoBox,
} from './styled'

export default function AppBar() {
  const showMobileMenu = useMobileMenu((state) => state.showMobileMenu)
  const { t } = useTranslation('features')

  const setShowMobileMenu = useMobileMenu(
    (state) => state.setShowMobileMenu
  ) as Dispatch<SetStateAction<boolean>>

  const theme = useTheme()
  const mdAndUp = useMediaQuery(theme.breakpoints.up('md'))

  useEffect(() => {
    if (showMobileMenu) {
      document.body.setAttribute('style', 'overflow-y: hidden')
    }

    if (!showMobileMenu) {
      document.body.removeAttribute('style')
    }
  }, [showMobileMenu])

  return (
    <>
      <StyledAppBar>
        <StyledToolbar disableGutters={true}>
          <Container maxWidth="lg">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Link
                href="/"
                lineHeight={0}
                onClick={() => setShowMobileMenu(false)}
              >
                <StyledLogoBox>
                  <FundLogo width="100%" />
                </StyledLogoBox>
              </Link>

              {mdAndUp && (
                <>
                  <NavBar />
                  <LangMenu />

                  <StyledInvestmentAccountButton
                    target="_blank"
                    href="https://portal.avantfunds.cz/login.php"
                  >
                    {t('app bar.investment-account')}
                  </StyledInvestmentAccountButton>
                </>
              )}

              {!mdAndUp && (
                <Box mr={-1.5}>
                  <IconButton sx={{ p: 0 }}>
                    <Hamburger
                      toggled={showMobileMenu}
                      toggle={setShowMobileMenu}
                      color={theme.palette.text.primary}
                      size={24}
                    />
                  </IconButton>
                </Box>
              )}
            </Stack>
          </Container>
        </StyledToolbar>
      </StyledAppBar>

      <StyledDrawer
        transitionDuration={500}
        open={showMobileMenu && !mdAndUp}
        anchor="top"
        variant="temporary"
      >
        <MobileMenu />
      </StyledDrawer>
    </>
  )
}
